import { PeriodType } from '../../../widget/date-range.widget.model';

export const periodTypeDays = {
    [PeriodType.ROLLING_30]: 29,
};
